import { hasAppAudience } from "../../../access-control/models/access-groups.models";
import { useAuthContext } from "../../../auth/state/AuthContext";
import VesselCardPage from "../pages/VesselCardPage";
import { canAccessVesselCard } from "../utils/vessel-card-access.utils";
import { Navigate } from "react-router-dom";

// Uses the same role grant and test-account override as the standalone Sidebar link.
const VesselCardRouteGate = () => {
  const user = useAuthContext().state.user;
  const token = user?.accessToken;

  if (!hasAppAudience(token?.groups ?? []) || !canAccessVesselCard(token, user?.accessControl)) {
    return <Navigate to="/errors/403" replace />;
  }

  return <VesselCardPage />;
};

export default VesselCardRouteGate;
